import { Component, OnInit } from '@angular/core';
import { ClassTemplate } from '../../models/classTemplate';
import { ClassTemplateService } from '../../services/class-template.service';
import { Gym } from '../../models/gym';
import { User } from '../../models/user';
import { GymService } from '../../services/gym.service';
import { Activity } from '../../models/activity';
import { ActivityService } from '../../services/activity.service';
import { UserService } from '../../services/user.service';
import * as userRoles from '../../config/UserRoles';

@Component({
  selector: 'app-class-template',
  templateUrl: './class-template.component.html',
  styleUrls: ['./class-template.component.scss']
})
export class ClassTemplateComponent implements OnInit {

  public ErrorMsg: string;
  public editMode: boolean;

  public listOfGyms: Array<Gym>;
  public listOfActivities: Array<Activity>;
  public listOfClassTemplates: Array<ClassTemplate>;
  public activityToPush: any;
  public listOfUsers: Array<User>;
  public activitiesToAdd: Array<any>;
  public editingClassTemplate: ClassTemplate;

  constructor(
    private classTemplateService: ClassTemplateService,
    private activityService: ActivityService,
    private gymService: GymService,
    private userService: UserService) {
    }

  ngOnInit() {
    this.editMode = false;
    this.editingClassTemplate = new ClassTemplate();
    this.editingClassTemplate.sequence = [];
    this.editingClassTemplate.gyms = [];
    this.activitiesToAdd = [];
    this.activityService.getAllActivities().then((activities) => {
      this.listOfActivities = activities;
    });
    this.classTemplateService.getAllClassTemplates().then((classTemplates) => {
      this.listOfClassTemplates = classTemplates;
    });
    this.userService.listUsersByRole(userRoles.USER_GYM_OWNER).then((users: Array<User>) => {
      this.listOfUsers = users;
    });
  }

  public addActivity() {
    this.listOfActivities.forEach(activity => {
      if (this.activityToPush === activity._id) {
        this.activitiesToAdd.push(activity);
      }
    });
  }

  public removeActivity(index) {
    this.activitiesToAdd.splice(index, 1);
  }

  public addClassTemplate() {
    const flattenActiviesSequence: Array<string> = [];
    this.activitiesToAdd.forEach((activity: any) => {
        flattenActiviesSequence.push(activity._id);
    });
    this.editingClassTemplate.sequence = flattenActiviesSequence;
    this.editingClassTemplate.gyms.forEach((gymToAdd, index) => {
      this.editingClassTemplate.gyms[index] = gymToAdd._id;
    });
    if (this.editingClassTemplate.name && this.editingClassTemplate.gyms
         && this.editingClassTemplate.sequence.length > 0) {
      this.classTemplateService.addClassTemplate(this.editingClassTemplate)
        .subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name, Sequence and Gyms Are Required.';
    }
  }

  public delClassTemplate(id) {
    this.classTemplateService.delClassTemplate(id).subscribe(() => { this.ngOnInit(); });
  }

  public isActivityChecked(selectedActivity) {
    if (this.editingClassTemplate.sequence.find(item => item._id === selectedActivity._id)) {
      return true;
    }
  }

  public isGymChecked(selectedGym) {
    if (this.editingClassTemplate.gyms.find(item => item._id === selectedGym._id)) {
      return true;
    }
  }

  setGym() {
    this.gymService.getAllGymsOwnedBy(this.editingClassTemplate.ownedBy).then((gyms) => {
      this.listOfGyms = gyms;
    });
  }

  public setClassTemplateSequence(selectedAcitivty) {
    const index = this.editingClassTemplate.sequence.findIndex(x => x._id === selectedAcitivty._id);
    if (index >= 0) {
      this.editingClassTemplate.sequence.splice(index, 1);
    } else {
      this.editingClassTemplate.sequence.push(selectedAcitivty);
    }
  }

  public setClassTemplateToEdit(classTemplate) {
    this.editMode = true;
    this.editingClassTemplate = classTemplate;
    this.activitiesToAdd = this.editingClassTemplate.sequence;
    this.setGym();
  }

  public setClassTemplateGym(selectedGym) {
    const index = this.editingClassTemplate.gyms.findIndex(x => x._id === selectedGym._id);
    if (index >= 0) {
      this.editingClassTemplate.gyms.splice(index, 1);
    } else {
      this.editingClassTemplate.gyms.push(selectedGym);
    }
  }

  public editClassTemplate() {
    this.editingClassTemplate.sequence = this.activitiesToAdd;
    if (this.editingClassTemplate.name
        && this.editingClassTemplate.sequence.length > 0
        && this.editingClassTemplate.gyms.length > 0) {
      this.classTemplateService.editClassTemplate(this.editingClassTemplate)
        .subscribe(() => { this.ngOnInit(); });
    } else {
      this.ErrorMsg = 'Name, Sequence and Gyms Are Required.';
    }
  }

  public quitEditingMode() {
    this.editMode = false;
    this.editingClassTemplate = new ClassTemplate();
    this.editingClassTemplate.sequence = [];
    this.editingClassTemplate.gyms = [];
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/class-template/class-template.component.ts